import { render, staticRenderFns } from "./AnophData.vue?vue&type=template&id=dd010c74&"
import script from "./AnophData.vue?vue&type=script&lang=js&"
export * from "./AnophData.vue?vue&type=script&lang=js&"
import style0 from "./AnophData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports